



























import Vue, { PropType } from 'vue';
import { Tab } from '@/models/tabs';

export default Vue.extend({
  name: 'ATabs',
  props: {
    items: { type: Array as PropType<Tab[]>, required: true },
    value: { type: [String, Number], required: true },
    boxed: Boolean,
  },
});
